export const imagestus = [
  {
    _id: 0,
    name: "ทั้งหมด",
  },
  { _id: 1, name: "รอ Up รูป" },
  { _id: 2, name: "Up รูปแล้ว" },
];
